<template>
  <div class="mask">
    <div class="dialog">

      <div style="width: 100%;text-align: center;font-size: 14px;font-weight: bold">最美证件照制作隐私政策</div>
      <div style="flex-wrap: wrap;font-size: 12px;color: #35315C;width: 80%;padding: 20px 20%">
        欢迎使用最美证件照制作！最美证件照制作非常重视您的隐私和个人信息保护。所以在您使用最美证件照制作前，请认真阅读我们的
        <a @click="ysxy" style="color:#FF7BAC;cursor: pointer">《隐私协议》</a>
        和
        <a @click="yhxy" style="color:#FF7BAC;cursor: pointer">《用户协议》</a>
        ，您同意并接受全部条款后方可开始使用最美证件照制作
      </div>
      <div style="width: 79%;display: flex;justify-content: space-between">
        <div @click="cancel" class="btn-cancel">取消</div>
        <div @click="ok" class="btn-ok">同意</div>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
        name: "AgreementDialog",
        methods:{
            cancel(){
                this.$emit('close',false)
            },
            ok(){
                this.$emit('close',false)
                this.$router.push({
                    path:'/uploadPhoto'
                })
            },
            ysxy(){
                window.open('http://www.id-photo-verify.com/privacy-zuimei-personal/')
            },
            yhxy(){
                window.open('https://operation.id-photo-verify.com/apps/ZuiMeiMake/UserAgreement/index.html')
            }
        }
    }
</script>

<style scoped>
  .mask{
    background-color: rgba(0,0,0,0.4);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
  }
  .dialog{
    width: 25%;
    background-color:white ;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;
    padding: 20px 0;

  }
  .btn-cancel{
    width: 46%;
    height: 3vw;
    border-radius: 1.5vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F5F6FA;
    color: #35315C;
    font-size: 12px;
    cursor: pointer;
  }
  .btn-ok{
    width: 46%;
    height: 3vw;
    border-radius: 1.5vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #4B00A4;
    color: #ffffff;
    font-size: 12px;
    cursor: pointer;
  }

</style>
